import { Component, inject, OnInit } from '@angular/core';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ChartPieAngle } from 'src/app/Interfaces/Admin/charts/ChartPieAngle.interface';
import { LargeArea } from 'src/app/Interfaces/Admin/charts/LargeChartArea.interface';
import { ChartPie, DataPie } from 'src/app/Interfaces/Admin/charts/SimpleCharPie.interface';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { Cont_Stadistic_CCP, Data_Complete_Cont_CCP, Data_Cont_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Reports/Data_Contribution_CCP.interface';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-contributions-ccp',
    templateUrl: './contributions-ccp.component.html',
    styleUrls: ['./contributions-ccp.component.scss', '../../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class ContributionsCCPComponent implements OnInit {
  //+================== VARIABLES GENERAL ==================+\\
  public EndDate!: Date
  public StartDate!: Date

  //+================== VARIABLES DATA LIBRARIES ==================+\\
  public DataChartAreaCCP: LargeArea = { Data: [], Date: [], SerieName: 'Contribuciones', Subtitle: ``, Title: 'Contribuciones totales CCP', Total: 0, load: true }
  public DataContributions: Data_Complete_Cont_CCP = {
    total: 0,
    media: 0,
    peak: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
    totalCurrent: 0
  }
  public DataChartPieCCP: ChartPie = { Title: 'General CCP', percent: 75, Data: [], load: true }
  public DataChartPieAngleCCP: ChartPieAngle = { Title: 'Actuales en sistema', Percent: 75, InnerPercent: 40, Data: [], load: true }

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== VARIABLES FOR TYPE FILES ==================+\\
  public Option_Type_Filter: any[] = [
    { Name: 'Día', Value: 1 },
    { Name: 'Semana', Value: 2 },
    { Name: 'Mes', Value: 3 },
    { Name: 'Año', Value: 4 }
  ];


  //+================== VARIABLES OPTIONS ==================+\\
  public Select_Option_Type_Filter = { Name: 'Mes', Value: 3 };

  //+================== VARIABLES FOR STATUS ==================+\\
  public Status_CCP = {
    Approved: 1,
    Pending: 2,
    Rejected: 3
  }

  public LoadPage: boolean = false;

  //-========================= SERVICES =========================-\\
  public Service_CCP = inject(LIBRARYCCPService)


  ngOnInit(): void {
    this.EndDate = new Date();
    this.Load_Cont_CCP();
  }

  //-================== FUNCTTION FOR LOAD CONT CCP ==================-\\
  private async Load_Cont_CCP(): Promise<void> {

    try {
      this.LoadPage = false;

      const resContributionCCP: Response_CCP = await firstValueFrom(this.Service_CCP.Get_Contribution_CCP({ Type: this.Select_Option_Type_Filter.Value, StartDate: this.StartDate ?? '', EndDate: this.EndDate }))

      if (resContributionCCP.success) {

        const DataContribution: Data_Cont_CCP[] = resContributionCCP.operation.Data
        const totalContribution: number = resContributionCCP.operation.total

        this.StartDate = moment(DataContribution[0].DateD, 'DD/MM/YYYY').toDate() ?? ''

        this.DataChartAreaCCP = {
          ...this.DataChartAreaCCP,
          Data: DataContribution.map((item: Data_Cont_CCP) => item.DataD),
          Date: DataContribution.map((item: Data_Cont_CCP) => item.DateD),
          Subtitle: `Periodo: ${moment(this.StartDate).utc().format('MM/DD/YYYY')} - ${moment(this.EndDate).utc().format('DD/MM/YYYY')}`,
          Total: totalContribution
        };

        const currentContribution: Cont_Stadistic_CCP[] = resContributionCCP.operation.currentContribution;

        this.DataContributions = {
          ...this.DataContributions,
          total: resContributionCCP.operation.total,
          media: Math.round(resContributionCCP.operation.media),
          peak: resContributionCCP.operation.peak,
          approved: currentContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Approved)?.Total_Status ?? 0,
          pending: currentContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Pending)?.Total_Status ?? 0,
          rejected: currentContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Rejected)?.Total_Status ?? 0,
          totalCurrent: currentContribution.reduce((total, item: Cont_Stadistic_CCP) => total + item.Total_Status, 0)
        }

        const generalContribution: Cont_Stadistic_CCP[] = resContributionCCP.operation.generalContribution;

        const generalApproved: DataPie = { name: 'Aprobadas', value: generalContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Approved)?.Total_Status ?? 0 }
        const generalRejected: DataPie = { name: 'rechazadas', value: generalContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Rejected)?.Total_Status ?? 0 }

        const DataPieGeneral: DataPie[] = [];
        DataPieGeneral.push(generalApproved, generalRejected);

        this.DataChartPieCCP = {
          ...this.DataChartPieCCP,
          Data: DataPieGeneral
        }

        const currentApproved: DataPie = { name: 'Aprobadas', value: currentContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Approved)?.Total_Status ?? 0 }
        const currentPending: DataPie = { name: 'Pendientes', value: currentContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Pending)?.Total_Status ?? 0 }
        const currentRejected: DataPie = { name: 'rechazadas', value: currentContribution.find((item: Cont_Stadistic_CCP) => item.Status === this.Status_CCP.Rejected)?.Total_Status ?? 0 }

        const DataPieCurrent: DataPie[] = [];
        DataPieCurrent.push(currentApproved, currentPending, currentRejected);

        this.DataChartPieAngleCCP = {
          ...this.DataChartPieAngleCCP,
          Data: DataPieCurrent
        }

      }

      this.LoadPage = true;

    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (contribuciones CCP)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      this.LoadPage = true;
    }

  }

  public Reload_Page(): void {
    this.Load_Cont_CCP();
  }

}
